
<template>
  <div class="nav-steps">
    <div class="step" :class="{ active: step >= 0 }">شروع</div>
    <div class="step" :class="{ active: step >= 1 }">درخواست ارسال شده</div>
    <div class="step" :class="{ active: step >= 2 }">در حال بررسی</div>
    <div class="step" :class="{ active: step >= 3 }">
      در انتظار تایید درگاه بانکی
    </div>
    <div class="step" :class="{ active: step >= 4 }">
      در انتظار تایید شاپرک
    </div>
    <div class="step" :class="{ active: step >= 5 }">پایان</div>
  </div>
</template>
<style lang="scss" scoped>
.nav-steps {
  display: flex;
  .step {
    flex-grow: 1;
    text-align: center;
    border-bottom: 5px solid rgb(136, 136, 136);
    margin-right: 1px;
  }
  .active {
    border-bottom-color: rgb(255, 103, 32);
  }
}
</style>
<script>
export default {
  name: "time-line",
  props: {
    step: {
      type: Number,
    },
  },
};
</script>